import { Typography } from "@circle-react-uikit/Typography";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";

import { WarningWrapper } from "./WarningWrapper";

export const SubscriptionIncompleteExpired = () => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <Banner
        variant="destructive"
        icon="triangle-exclamation"
        iconColor="danger"
        title={t("subscription.incomplete_expired_title")}
        description={t("subscription.incomplete_expired_description")}
      />
    );
  }

  return (
    <WarningWrapper>
      <Typography.LabelLg weight="semibold">
        {t("subscription.incomplete_expired_title")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("subscription.incomplete_expired_description")}
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
